import React, { useMemo } from 'react';
import { IUpdatePolicyPremiumDetailsRequest } from 'types/order/title/IPolicyPremiumDetailsResponse';
import { BodyText, Button, Grid } from 'ui-toolkit/components';

const getBodyText = (holdOpenAvailable: boolean, holdOpen?: boolean) => {
  if (!holdOpenAvailable) {
    return 'Hold Open not available for this order!';
  }
  if (holdOpen) {
    return 'Remove the hold open for this order?';
  }
  return 'Please confirm that a hold open should be issued for this order.';
};

export const ChangeHoldOpenFormModal: React.FC<{
  handleCancel: () => void;
  handleSubmit: (updateRequest: IUpdatePolicyPremiumDetailsRequest) => void;
  holdOpen: boolean;
  holdOpenAvailable: boolean;
}> = ({ handleCancel, handleSubmit, holdOpen, holdOpenAvailable }) => {
  const bodyText = useMemo(() => getBodyText(holdOpenAvailable, holdOpen), [holdOpenAvailable, holdOpen]);
  return (
    <Grid>
      <BodyText>{bodyText}</BodyText>
      <Grid templateColumns={`1fr max-content`} textAlign={'right'}>
        <Grid />
        <Grid templateColumns={'max-content max-content'}>
          <Button intent={'danger'} onClick={() => handleCancel()}>
            Cancel
          </Button>
          <Button intent={'danger'} onClick={() => handleSubmit({ holdOpen: !holdOpen })}>
            {holdOpen ? 'Remove' : 'Issue'}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};
